/**
 * useViewMode Hook
 * 
 * Manages view mode state and modal state for the Sales component.
 */

import { useState } from 'react';
import { type ViewMode, type ModalType } from '../utils';

interface UseViewModeReturn {
  viewMode: ViewMode;
  setViewMode: React.Dispatch<React.SetStateAction<ViewMode>>;
  activeModal: ModalType;
  setActiveModal: React.Dispatch<React.SetStateAction<ModalType>>;
  blocked: boolean;
  setBlocked: React.Dispatch<React.SetStateAction<boolean>>;
  isSelectionMode: boolean;
  setIsSelectionMode: React.Dispatch<React.SetStateAction<boolean>>;
  targetSelections: string[] | undefined;
  setTargetSelections: React.Dispatch<React.SetStateAction<string[] | undefined>>;
}

/**
 * Custom hook to manage view mode and modal state
 */
export const useViewMode = (): UseViewModeReturn => {
  const [viewMode, setViewMode] = useState<ViewMode>('order');
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const [blocked, setBlocked] = useState(false);
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [targetSelections, setTargetSelections] = useState<string[] | undefined>(undefined);

  return {
    viewMode,
    setViewMode,
    activeModal,
    setActiveModal,
    blocked,
    setBlocked,
    isSelectionMode,
    setIsSelectionMode,
    targetSelections,
    setTargetSelections,
  };
};
